import {
    VIEWSUBADMINMGMTLISTADMIN_SUCCESS,
    VIEWSUBADMINMGMTLISTADMIN_FAILED,
    RESET_VIEWSUBADMINMGMTLISTADMIN,
    LOADING_VIEWSUBADMINMGMTLISTADMIN,
    NETWORK_ERROR_VIEWSUBADMINMGMTLISTADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_VIEWSUBADMINMGMTLISTADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case VIEWSUBADMINMGMTLISTADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case VIEWSUBADMINMGMTLISTADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_VIEWSUBADMINMGMTLISTADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_VIEWSUBADMINMGMTLISTADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
